/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '../typography/Typography';

const DrawerTitle = ({ ornament, title, variant }) => {
  if (!ornament && !title) return null;
  return (
    <div className="sui-relative sui-flex sui-items-center sui-gap-x-2">
      {ornament}
      <Typography variant={variant}>{title}</Typography>
    </div>
  );
};

DrawerTitle.displayName = 'DrawerTitle';

DrawerTitle.propTypes = {
  ornament: PropTypes.node,
  title: PropTypes.string,
  variant: PropTypes.string
};

DrawerTitle.defaultProps = {
};

export { DrawerTitle };